/* eslint-disable */
import storeApis from "../../api/storeApi";
import {cleanUserData} from "../actions/chatAiActions"

const LOGIN_URL = "login";

//Get Login Content
export const getLoginContent = () => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get(LOGIN_URL);
      if (response.status === 200) {
        await dispatch(cleanUserData());
        await dispatch({
          type: "GET_LOGIN_CONTENT",
          payload: response.data.data,
        });
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
    }
  };
};

//Resend Email
export const resendMailRequest = (data) => {
  return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
          const response = await storeApis.post(
            "/resendEmail",
             {
              first_name: data?.first_name,
              last_name: data?.last_name,
              email:data?.email,
              id:data?.id,
             },
              // {
              //     headers: {
              //         Accept: "application/json",
              //         Authorization: `Bearer ${authToken}`,
              //     },
              // }
          );
          if (response.status === 200) {
              if (response.data.statusCode == "403") {
                  console.log(response.data,"Resend Api")
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
              }else {
                  console.log(response.data,"Resend Api")
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
              }
          }
      } catch (err) {
          Toast(err.response.message, "E");
          dispatch({ type: "UNAUTHORIZED", payload: err.response.status });

      }
  };
};
